import React, { useState, useEffect } from "react";
import { _get, _post } from "../services/apiClient";
import { apiUrls } from "../config/apiUrls.const";

export default function About() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        // example request — replace with your real endpoint and payload
        const response = await _get(apiUrls?.getBusinesses);
        setData(response.data); // axios response has `data`
      } catch (err: any) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return (
    <>
      <h1 className="page-header">About Us</h1>
      <hr className="section-devider" />
      {loading && <p>Loading...</p>}
      {error && <p className="text-danger">{error}</p>}
      {data && (
        <div>
          <h4>{data.title}</h4>
          <p>{data.description}</p>
        </div>
      )}
    </>
  );
}
